import { Stack, Typography } from 'libs/ui';
import { CSSObject, styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const ContentStyled = styled(Stack)(() => ({
  gap: 12,

  '.notificationChangeOnboardingStatus-clientName': {
    textDecoration: 'underline',
    color: Colors.blue500,

    '&:hover': {
      color: Colors.hover,
    } as CSSObject,
  } as CSSObject,

  '.notificationChangeOnboardingStatus-prevStatus': {
    textDecoration: 'line-through',
    color: Colors.gray600,
  } as CSSObject,
}));

export const ArrowRightWrapper = styled(Typography)(() => ({
  verticalAlign: 'middle',
}));
